var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayLargeCustomClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.89 8C22.307 8 8 22.306 8 39.89c0 17.584 14.306 31.89 31.89 31.89 17.584 0 31.89-14.306 31.89-31.89C71.78 22.305 57.474 8 39.89 8zm0 59.21c-15.063 0-27.318-12.257-27.318-27.32 0-15.064 12.255-27.319 27.319-27.319 15.063 0 27.318 12.255 27.318 27.318 0 15.064-12.255 27.32-27.318 27.32z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.288 39.356H41.302V22.974a2.286 2.286 0 1 0-4.572 0v18.667a2.286 2.286 0 0 0 2.286 2.286h17.272a2.286 2.286 0 1 0 0-4.571z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayLargeCustomClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-large-custom-clock.70796c9421bc8fc7f73deafb0dfaf42c.svg";